import { MicOff } from 'lucide-react'

type MuteIndicatorProps = {
  isMuted: boolean
  size?: 'sm' | 'md'
}

/**
 * Mute indicator component
 * Displays a microphone off icon when participant is muted
 * Similar to Google Meet's mute indicator
 */
export const MuteIndicator = ({ isMuted, size = 'sm' }: MuteIndicatorProps) => {
  if (!isMuted) return null

  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4'
  }

  return (
    <div
      className="flex items-center justify-center rounded-full bg-black/60 p-1 backdrop-blur-sm"
      aria-label="Microphone coupé"
    >
      <MicOff className={`${sizeClasses[size]} text-white`} />
    </div>
  )
}
